var React = require('react');

function ItsTimeTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M64.7481 60.4583L96.8006 2.50408L133.548 99.221L64.7481 60.4583Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M0.980877 58.676L96.9135 2.50618L64.8741 60.3727L0.980877 58.676Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M0.984375 58.6787L64.8326 60.3742L133.556 99.223L0.984375 58.6787Z","fill":"#5915C7","key":2})]);
}

ItsTimeTriangle.defaultProps = {"width":"137","height":"100","viewBox":"0 0 137 100","fill":"none"};

module.exports = ItsTimeTriangle;

ItsTimeTriangle.default = ItsTimeTriangle;
